<template>
  <van-tabbar
    v-model="active"
    placeholder
    :border="false"
    active-color="#DA4E35"
    inactive-color="#8E7D7D"
  >
    <van-tabbar-item replace to="/">
      <span>{{ t('e6') }}</span>
      <template #icon="props">
        <img :src="props.active ? icon.active : icon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/pledge">
      <span :class="{ mini: lang === 'rw' }">{{ t('e7') }}</span>
      <template #icon="props">
        <img :src="props.active ? icon1.active : icon1.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/nft">
      <span>NFT</span>
      <template #icon="props">
        <img :src="props.active ? icon2.active : icon2.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/superApp">
      <span>SUPERAPP</span>
      <template #icon="props">
        <img :src="props.active ? icon3.active : icon3.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to="/mine">
      <span>{{ t('e8') }}</span>
      <template #icon="props">
        <img :src="props.active ? icon4.active : icon4.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup>
  import { ref, watch } from 'vue'
  import { useRoute } from "vue-router"
  import { useI18n } from "vue-i18n"

  const { t, locale } = useI18n()
  const lang = ref('')
  watch(() => locale.value, (newLang, oldLang) => {
    lang.value = newLang
  }, { immediate: true })
  const route = useRoute()
  const active = ref(0)
  switch (route.path) {
    case '/':
      active.value = 0
      break;
    case '/pledge':
      active.value = 1
      break;
    case '/nft':
      active.value = 2
      break;
    case '/superApp':
      active.value = 3
      break;
    case '/mine':
      active.value = 4
      break;
  }

  const icon = {
    active: require('@/assets/img/icon_home_active.png'),
    inactive: require('@/assets/img/icon_home.png'),
  }
  const icon1 = {
    active: require('@/assets/img/icon_record_active.png'),
    inactive: require('@/assets/img/icon_record.png'),
  }
  const icon2 = {
    active: require('@/assets/img/icon_nft_active.png'),
    inactive: require('@/assets/img/icon_nft.png'),
  }
  const icon3 = {
    active: require('@/assets/img/icon_app_active.png'),
    inactive: require('@/assets/img/icon_app.png'),
  }
  const icon4 = {
    active: require('@/assets/img/icon_mine_active.png'),
    inactive: require('@/assets/img/icon_mine.png'),
  }
</script>
<style scoped lang="less">
:deep(.van-tabbar){
  background: url("@/assets/img/tabbar_bg.png") no-repeat;
  background-size: 100% auto;

  .van-tabbar-item--active{
    background: transparent;
  }

  .van-tabbar-item__text span{
    font-size: 10px;
  }
  .van-tabbar-item__text span.mini{
    font-size: 9px;
  }
}
</style>
